import SpecialistReviewAPI from "api/SpecialistReviewAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistReviews( params: SpecialistReviewsGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistReviewAPI.getAll,
      params: [ params ],
      debounce: true,
      clear_data_on_update: true
   })
}